/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const contactPageResponseOutputItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const contactPageResponseOutputItemsItemUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const contactPageResponseOutputItemsItemDestinationMax = 254;

export const contactPageResponseOutputItemsItemLabelMax = 80;

export const contactPageResponseOutputItemsItemPriorityMax = 100;

export const contactPageResponseOutputItemsItemVerifiedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const contactPageResponseOutputItemsItemVerificationRequestedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const contactPageResponseOutputItemsItemDestinationRevisionExclusiveMin = 0;
export const contactPageResponseOutputItemsItemDestinationRevisionMax = 9007199254740991;

export const contactPageResponseOutputItemsItemAvailableVerificationTransportsMax = 3;

export const contactPageResponseOutputItemsItemVersionExclusiveMin = 0;
export const contactPageResponseOutputItemsItemVersionMax = 9007199254740991;

export const contactPageResponseOutputItemsItemCreatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const contactPageResponseOutputItemsItemUpdatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const contactPageResponseOutputNextCursorOneMax = 512;

export const contactPageResponseOutputNextCursorOneRegExp = new RegExp('^[A-Za-z0-9_-]+$');

export const ContactPageResponseOutput = zod.object({
  items: zod.array(
    zod.object({
      id: zod.uuid().regex(contactPageResponseOutputItemsItemIdRegExp),
      userId: zod.uuid().regex(contactPageResponseOutputItemsItemUserIdRegExp),
      kind: zod.enum(['email', 'telephone']),
      destination: zod.string().min(1).max(contactPageResponseOutputItemsItemDestinationMax),
      label: zod.string().min(1).max(contactPageResponseOutputItemsItemLabelMax),
      priority: zod.int().min(1).max(contactPageResponseOutputItemsItemPriorityMax),
      enabled: zod.boolean(),
      verifiedAt: zod.union([
        zod.iso
          .datetime({ offset: true })
          .regex(contactPageResponseOutputItemsItemVerifiedAtOneRegExp),
        zod.null(),
      ]),
      verificationRequestedAt: zod
        .union([
          zod.iso
            .datetime({ offset: true })
            .regex(contactPageResponseOutputItemsItemVerificationRequestedAtOneRegExp),
          zod.null(),
        ])
        .optional(),
      destinationRevision: zod
        .int()
        .gt(contactPageResponseOutputItemsItemDestinationRevisionExclusiveMin)
        .max(contactPageResponseOutputItemsItemDestinationRevisionMax),
      smsEnabled: zod.boolean(),
      voiceEnabled: zod.boolean(),
      availableVerificationTransports: zod
        .array(zod.enum(['email-link', 'sms-code', 'voice-code']))
        .max(contactPageResponseOutputItemsItemAvailableVerificationTransportsMax)
        .optional(),
      version: zod
        .int()
        .gt(contactPageResponseOutputItemsItemVersionExclusiveMin)
        .max(contactPageResponseOutputItemsItemVersionMax),
      createdAt: zod.iso
        .datetime({ offset: true })
        .regex(contactPageResponseOutputItemsItemCreatedAtRegExp),
      updatedAt: zod.iso
        .datetime({ offset: true })
        .regex(contactPageResponseOutputItemsItemUpdatedAtRegExp),
    }),
  ),
  nextCursor: zod.union([
    zod
      .string()
      .min(1)
      .max(contactPageResponseOutputNextCursorOneMax)
      .regex(contactPageResponseOutputNextCursorOneRegExp),
    zod.null(),
  ]),
});

export type ContactPageResponseOutput = zod.input<typeof ContactPageResponseOutput>;
export type ContactPageResponseOutputOutput = zod.output<typeof ContactPageResponseOutput>;
